const scrollSection = () => {
    const triggers = document.querySelectorAll('.js-scroll-section');

    if ( triggers ) {
        triggers.forEach(trigger => {
            trigger.addEventListener('click', (event) => {
                event.preventDefault();
    
                const currentSection = trigger.closest('section');
                const nextSection = currentSection.nextElementSibling;
    
                if ( nextSection ) {
                    const sectionRect = nextSection.getBoundingClientRect();
                    const headerHeight = document.querySelector('.c-header').offsetHeight;
        
                    window.scrollTo({
                        top: (sectionRect.top - headerHeight) + window.scrollY,
                        behavior: 'smooth',
                    });
                }
            });
        });
    }
}

scrollSection();